
export function getBrowser(){
  const userAgent = window.navigator.userAgent;
  const chromium = userAgent.match(/chrome|chromium|crios/i);
  if(userAgent.match(/edg/i)){
    return "edge";
  } else if(userAgent.match(/firefox|fxios/i)){
    return "firefox";
  }  else if(userAgent.match(/safari/i) && !chromium){
    return "safari";
  } else if(userAgent.match(/opr\//i)){
    return "opera";
  } else if(chromium){
    return "chrome";
  } 
  return 'other';
}

export function getPlatform(){
  if(isAndroid()){
    return 'android';
  } else if (isIOS()){
    return 'ios';
  } else if (isElectron()){
    return 'electron';
  }
  return 'other';
}

export function isElectron(){
  return window.navigator.userAgent.indexOf("Electron") > -1;
}

export function isAndroid(){
  return /Android/i.test(window.navigator.userAgent)
}

export function isIOS(){
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(window.navigator.platform)
  // iPad on iOS 13 detection
  || (window.navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

const userAgent = {
  browser: getBrowser(),
  platform: getPlatform()
}

export default userAgent